import React, { useState } from 'react';
import styles from './Communications.module.scss';

import { Tabs } from 'tt-ui-lib/core';
import UsersTab from './components/tabs/Users';
import TemplatesTabs from './components/tabs/Templates';
import MailingListTab from './components/tabs/MailingList';

const CommunicationsAdminPage = () => {
  const tabs = [
    { id: 'users', name: 'Users', disabled: true },
    { id: 'templates', name: 'Templates', disabled: false },
    {
      id: 'mailing-lists',
      name: 'Mailing Lists',
      disabled: true,
      child: [
        { id: 'sheduled', name: 'Scheduled' },
        { id: 'sent', name: 'Sent' },
      ],
    },
  ];

  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedChildTab, setSelectedChildTab] = useState(0);

  const handleChangeTab = (newValue) => {
    setSelectedTab(newValue);
    setSelectedChildTab(0);
  };

  const handleChangeChildTab = (newValue) => {
    setSelectedChildTab(newValue);
  };

  const tabRender = () => {
    switch (selectedTab) {
      case 0:
        return <UsersTab />;
      case 1:
        return <TemplatesTabs />;
      case 2:
        return <MailingListTab selectedChildTab={selectedChildTab} />;
      default:
        return <b>Coming soon...</b>;
    }
  };

  return (
    <div className={styles.pageContainer}>
      <Tabs
        tabs={tabs}
        selectedTab={selectedTab}
        onChangeTab={handleChangeTab}
        selectedChildTab={selectedChildTab}
        onChangeChildTab={handleChangeChildTab}
      />

      <div className={styles.tabContainer}>{tabRender()}</div>
    </div>
  );
};

export default CommunicationsAdminPage;
